import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./createOrder.module.scss";
import { postCall, getCookie } from "../../utils/utils";

const Index = () => {
  const history = useHistory();
  const showAuto = (JSON.parse(localStorage.getItem('env_const') || {})?.showAuto) == 'true';
  const showBike = (JSON.parse(localStorage.getItem('env_const') || {})?.showBike) == 'true';

  const handleOrder = (redirectUrl) => {
    const url = JSON.parse(localStorage.getItem('env_const'))?.purchase_url || ""
    postCall(`${url}/cloakCustomer`, {
      redirectUrl,
      exp_order_source_id: getCookie("exp_order_source_id"),
    })
  };

  return (
    <div className={styles["wrapper"]}>
      <img
        src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/extendedWarranty/BackArrowWithWhiteBackground.svg"
        alt="back"
        className={styles.backIcon}
        onClick={() => {
          history.goBack();
        }}
      />
      <div className={styles["content"]}>
        {/* <img
          src="https://d34kmefuuy0be0.cloudfront.net/ev_assets/add_icon_df2f4eccf5.svg"
          alt="add"
          className={styles["add-icon"]}
        /> */}
        <h2>Create order</h2>
        <p className={styles["options"]}>Choose an option to proceed</p>
        <div className={styles["cards"]}>
          <div
            onClick={() => {
              handleOrder("/");
            }}
          >
            <img
              src="https://assets.olaelectric.com/olaelectric-videos/configs-static/brandChampion/bcScooterIcon2.svg"
              alt="icon"
            />
            <div>
              <p>Scooter</p>
              <img
                src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/green-Arrow-right.svg"
                alt="right-arrow"
              />
            </div>
          </div>
         {showBike && <div
            onClick={() => {
              handleOrder("/bike");
            }}
          >
            <img
              src="https://assets.olaelectric.com/olaelectric-videos/configs-static/brandChampion/bcBikeIcon.svg"
              alt="icon"
            />
            <div>
              <p>Bike</p>
              <img
                src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/green-Arrow-right.svg"
                alt="right-arrow"
              />
            </div>
          </div>}
         {showAuto && <div
            onClick={() => {
              handleOrder("/auto");
            }}
          >
            <img
              src="https://assets.olaelectric.com/olaelectric-videos/configs-static/brandChampion/bcAutoIcon.svg"
              alt="icon"
            />
            <div>
              <p>Auto</p>
              <img
                src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/green-Arrow-right.svg"
                alt="right-arrow"
              />
            </div>
          </div>}
          <div
            onClick={() => {
              handleOrder("/accessoryStore");
            }}
          >
            <img
              src="https://assets.olaelectric.com/olaelectric-videos/configs-static/brandChampion/bcAccessoryIcon.svg"
              alt="icon"
            />
            <div>
              <p>Accessories</p>
              <img
                src="https://assets.olaelectric.com/olaelectric-videos/configs-static/assets/images/green-Arrow-right.svg"
                alt="right-arrow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
